import { initialState } from "reducers/TextEditor/State";
import { TextEditor } from "constants/Actions";
import _ from "lodash";

const {
  SAVE_TEXT_DATA,
  SAVE_TEXT_DATA_SUCCESS,
  SAVE_TEXT_DATA_FAIL,

  SET_DRAWER_PROPERTIES,

  GET_STANDARD_ADAPTERS,
  GET_STANDARD_ADAPTERS_SUCCESS,
  GET_STANDARD_ADAPTERS_FAIL,

  DELETE_TEXT_DATA,
  DELETE_TEXT_DATA_SUCCESS,
  DELETE_TEXT_DATA_FAIL,
} = TextEditor;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case SAVE_TEXT_DATA:
      return Object.assign({}, state, {
        text: payload?.data,
      });
    case SAVE_TEXT_DATA_SUCCESS:
      return Object.assign({}, state, {
        text: { ...state.text },
      });
    case SAVE_TEXT_DATA_FAIL:
      return Object.assign({}, state, {
        text: { ...state.text },
      });
    case DELETE_TEXT_DATA:
      return Object.assign({}, state, {
        text: payload?.data,
        isDeleting: true,
      });
    case DELETE_TEXT_DATA_SUCCESS:
      return Object.assign({}, state, {
        text: initialState.text,
        isDeleting: false,
      });
    case DELETE_TEXT_DATA_FAIL:
      return Object.assign({}, state, {
        text: initialState.text,
        isDeleting: false,
      });
    case SET_DRAWER_PROPERTIES:
      return Object.assign({}, state, {
        drawer: payload?.data,
      });
    case GET_STANDARD_ADAPTERS:
      return Object.assign({}, state, {
        standardAdapters: {
          data: [],
          isLoading: true,
        },
      });
    case GET_STANDARD_ADAPTERS_SUCCESS:
      return Object.assign({}, state, {
        standardAdapters: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_STANDARD_ADAPTERS_FAIL:
      return Object.assign({}, state, {
        standardAdapters: {
          ...state.standardAdapters,
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
